/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const StepperComponent = (props) => {
    useEffect(() => {

    }, []);

    const stepClassName = (index) => {
        if (index < props.activeStep) return "step completed";
        if (index === props.activeStep) return "step active";
        return "step";
    };
    const stepCountClassName = (index) => {
        if (index < props.activeStep) return "stepper-count completed";
        if (index === props.activeStep) return "stepper-count active";
        return "stepper-count";
    };

    return (
        (props.screen && props.screen === 'customer' ?
            <div className="sales-ui-stepper-wrapper">
                {props.steps.map((label, i) => (
                    <div key={i} className={stepClassName(i)} onClick={() => props.onStepSelect(i)} style={{ cursor: 'pointer' }}>
                        <div style={{ display: 'flex', gap: '.4rem', alignItems: 'center' }}>
                            <span className={stepCountClassName(i)}>{i + 1}</span>
                            {/* <Avatar>{i + 1}</Avatar> */}
                            <span style={{ textWrap: 'nowrap' }}>{label}</span></div>
                    </div>
                ))}
            </div>
            : props.screen && props.screen === 'createPackage' ?
                <ul className="sales-ui-stepper-wrapper" style={{ padding: '0px', height: 'auto', overflowY: 'hidden' }}>
                    {props.steps.map((label, i) => (
                        <li key={i} className={stepClassName(label.value)} onClick={(e) => props.onStepSelect(e, label.value)} style={{ cursor: 'pointer' }}>
                            <div style={{ display: 'flex', gap: '.4rem', alignItems: 'center' }}>
                                <span className={stepCountClassName(label.value)}>{i + 1}</span>
                                {/* <Avatar>{i + 1}</Avatar> */}
                                <span className="text-caption" style={{ textWrap: 'nowrap' }}>{label.label}</span></div>
                        </li>
                    ))}
                </ul>
                :
                <ul className="sales-ui-stepper-wrapper">
                    {props.steps.map((label, i) => (
                        <li key={i} className={stepClassName(i)} onClick={() => i < props.activeStep && props.back(i)} style={{ cursor: 'pointer' }}>
                            <div style={{ display: 'flex', gap: '.4rem', alignItems: 'center' }}>
                                <span className={stepCountClassName(i)}>{i + 1}</span>
                                {/* <Avatar>{i + 1}</Avatar> */}
                                <span className="text-caption" style={{ textWrap: 'nowrap' }}>{label.label}</span></div>
                        </li>
                    ))}
                </ul>
        )


    );
}

// Fetch data from redux store
const mapStateToProps = state => {
    return {
        tenantData: state.auth.tenantData,
    }
};

// Set data to redux store  
const mapDispatchToProps = dispatch => {
    return {}
};

 export default connect(mapStateToProps, mapDispatchToProps)(StepperComponent)